import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import ActividadesHeader from "./ActividadesUtils/ActividadesHeader";
import BoxWrapper from "./ActividadesUtils/BoxWrapper";
import BoxHeader from "./ActividadesUtils/BoxHeader";
import ModalHeader from "./ActividadesUtils/ModalHeader";
import { useLocation } from "react-router-dom";
import {
  editBloques,
  getBloqueDetalle,
  getPracticarios,
} from "../../services/api";
import "react-toastify/dist/ReactToastify.css";
import ReactLoading from "react-loading";
import IconHTML from "../../../assets/icons/icons-bloques/icono_practicario.svg";
import ActWrapper from "./Actividades/ActividadesUtils/ActWrapper";
import { customStyles } from "./Actividades/ActividadesUtils/ActividadesUtils";
import { errorToast, successToast } from "./ActividadesUtils/FormularioUtils";
import InputBuscarMostrar from "../../fragments/Inputs/InputBuscarMostrar";
import AutosizeInput from "./ActividadesUtils/AutosizeInput";
import PracticariosPlayer from "./Actividades/PracticariosPlayer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

const ConstructorPracticarios = () => {
  
  const [loading, setLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const [inputList, setInputList] = useState("");
  const [inputListName, setInputName] = useState("");
  const [idInteractivo, setIdInteractivo] = useState("");
  const [nombreTituloActual, setNombreTituloActual] = useState("");
  const [nombreTitulo, setNombreTitulo] = useState("");
  const [instrucciones, setInstrucciones] = useState("");

  const [listIteractivo, setInteractivo] = useState([]);
  const [listPreview, setListPreview] = useState([]);

  const [interactivoExist, setInteractivoExist] = useState(false);

  const { state } = useLocation();
  const { uma, actividad, bloque, content } = state;

  const getInitialData = () => {
    const currentBlock = getBloqueDetalle(uma, content._id);

    currentBlock.then((res) => {
      const bloqueContent = res.data.html;
      const nombreContent = res.data.nombre_interactivo;
      const initialInstructions = res.data.texto;
      setInputList(bloqueContent);
      setNombreTitulo(nombreContent);
      setLoading(false);
      if (initialInstructions) setInstrucciones(initialInstructions);
    });
  };

  useEffect(() => {
    //setInteractivo(inputOptions);
    //setInteractivoB(listIteractivo);
    Modal.defaultStyles.overlay.backgroundColor = "rgb(84 84 84 / 75%)";
    Modal.defaultStyles.overlay.zIndex = "+99";
    getInitialData();

    getPracticarios().then((practicariosRes) => {
      //console.log(practicariosRes.data);
      setInteractivo(practicariosRes.data);
    });
  }, []);

  useEffect(() => {
    if (idInteractivo == "") {
      let myArray = inputList.split("/");
      setIdInteractivo(myArray[0]);
    }
  }, [inputList]);

  useEffect(() => {
    if (idInteractivo !== "" && listIteractivo.length > 0) {
      const found = listIteractivo.find((e) => e.id_titulo === idInteractivo);
      if (found) {
        const label = found.id_titulo + " - " + found.nombre + (found.tema ? " - " + found.tema : "");
        setInputName(label);
        setNombreTituloActual(label);
      }
    }
  }, [listIteractivo]);

  const handleOnSearch = () => {
    const palabra = document.getElementById("input-buscar").value.trim();

    if (palabra === "") {
      setInteractivoExist(false);
      setInputName("");
      setInputList("");
      setListPreview([]);
      setNombreTituloActual("");
      return;
    }

    const palabraLower = palabra.toLowerCase();
    const palabraUpper = palabra.toUpperCase();

    const filtered = listIteractivo
      .filter((item) =>
        item.id_titulo.toUpperCase().includes(palabraUpper) ||
        item.nombre.toLowerCase().includes(palabraLower)
      )
      .sort((a, b) => a.id_titulo.localeCompare(b.id_titulo))
      .map((item) => ({
        id: item.id_titulo,
        nombre: item.id_titulo + " - " + item.nombre + (item.tema ? " - " + item.tema : ""),
        url: item.url,
      }));

    setListPreview(filtered);

    const exactMatch = listIteractivo.find(
      (item) => item.id_titulo.toUpperCase() === palabraUpper
    );

    if (exactMatch) {
      setInteractivoExist(true);
      setInputName(exactMatch.id_titulo + " - " + exactMatch.nombre + (exactMatch.tema ? " - " + exactMatch.tema : ""));
      setInputList(exactMatch.id_titulo + "/" + exactMatch.url);
      setNombreTitulo(exactMatch.nombre);
    } else if (filtered.length > 0) {
      setInteractivoExist(true);
      setInputName(filtered[0].nombre);
      setInputList(filtered[0].id + "/" + filtered[0].url);
      setNombreTitulo(filtered[0].nombre.split(" - ").slice(1).join(" - "));
    } else {
      setInteractivoExist(false);
      setInputName("");
      setInputList("");
    }
  };

  const selectTitle = (id, nombre, url) => {
    setInputName(nombre);
    setInputList(id + "/" + url);
    setListPreview([]);

    document.getElementById("input-buscar").value = id;
  };

  const handleSubmit = () => {
    const body = {
      ...content,
      html: inputList,
      nombre_interactivo: nombreTitulo,
      texto: instrucciones,
    };
    if (inputList !== "") {
      setLoading(true);
      editBloques(uma, body, content._id).then((res) => {
        setInputList(res.data.html);
        setNombreTituloActual(inputListName);
        setInteractivoExist(false);
        successToast("Se ha guardado el proyecto satisfactoriamente.");
        setLoading(false);
      });
    } else {
      errorToast("Asegúrate de introducir un interactivo valido");
    }
  };

  function toggleModal() {
    setIsOpen(!isOpen);
  }

  function toggleInfoModal() {
    setIsInfoModalOpen(!isInfoModalOpen);
  }

  return (
    <>
      <ActividadesHeader
        renglonesLength={1}
        actIcon={IconHTML}
        title="Practicarios"
      />
      {loading && (
        <ReactLoading
          type="spin"
          color="#1A3D82"
          height={"5%"}
          width={"5%"}
          className="mt-72 m-auto"
        />
      )}
      {!loading && (
        <BoxWrapper>
          {nombreTituloActual === "" ? (
            <BoxHeader
              toggleModal={toggleModal}
              boxTitle={"Selecciona un código para crear tu actividad"}
              inputList={inputList}
            />
          ) : (
            <BoxHeader
              toggleModal={toggleModal}
              boxTitle={
                "Actualmente el practicario seleccionado es: " +
                nombreTituloActual
              }
              inputList={inputList}
            />
          )}
          <AutosizeInput
            label={"Instrucciones"}
            value={instrucciones}
            onChange={(e) => setInstrucciones(e.target.value)}
            placeholder={"Ingresa tus instrucciones (opcional)"}
            labelStyles="!font-normal text-[#606060]"
            styles="!border-[1px]"
          />
          <div>Practicario</div>
          <InputBuscarMostrar
            id="input-buscar"
            onKeyUp={() => handleOnSearch()}
            name={inputList}
            exist={interactivoExist}
            default
          />
          {inputListName != "" ? (
            <>
              <p className="mt-2">
                Practicario seleccionado: <b>{inputListName}</b>
              </p>
              {listPreview.map((value, index) => {
                <div className=""></div>;
                return (
                  <>
                    <p
                      className="flex justify-start search-option-container"
                      onClick={() =>
                        selectTitle(value.id, value.nombre, value.url)
                      }
                    >
                      {value.nombre}
                    </p>
                  </>
                );
              })}
            </>
          ) : (
            <p>Practicario: No se han encontrado coincidencias</p>
          )}

          <div className="flex justify-between items-center mt-6">
            <button
              onClick={toggleInfoModal}
              className="flex items-center gap-2 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
            >
              <FontAwesomeIcon icon={faInfoCircle} />
              Ver todos los practicarios
            </button>
            <button
              onClick={handleSubmit}
              className="btn-nimbus"
            >
              Guardar
            </button>
          </div>
        </BoxWrapper>
      )}
      <Modal
        isOpen={isOpen}
        onRequestClose={toggleModal}
        contentLabel="My dialog"
        style={customStyles}
      >
        <ModalHeader
          toggleModal={toggleModal}
          modalTitle={"Previsualización de actividad"}
        />
        <ActWrapper modoPrevisualizar caratula={false} tipo="memorama">
          <PracticariosPlayer interactivo={inputList} instrucciones={instrucciones} />
        </ActWrapper>
      </Modal>

      <Modal
        isOpen={isInfoModalOpen}
        onRequestClose={toggleInfoModal}
        contentLabel="Lista de practicarios"
        style={customStyles}
      >
        <ModalHeader
          toggleModal={toggleInfoModal}
          modalTitle={"Lista completa de practicarios"}
          noBorder={true}
        />
        <div className="p-4 max-h-[70vh] overflow-y-auto">
          {listIteractivo.length === 0 ? (
            <p className="text-center text-gray-500">No hay practicarios disponibles</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-nimbus text-white">
                    <th className="border border-gray-300 px-4 py-2 text-left">ID</th>
                    <th className="border border-gray-300 px-4 py-2 text-left">Nombre</th>
                    <th className="border border-gray-300 px-4 py-2 text-left">Tema</th>
                    <th className="border border-gray-300 px-4 py-2 text-left">Grado</th>
                  </tr>
                </thead>
                <tbody>
                  {listIteractivo
                    .sort((a, b) => a.id_titulo.localeCompare(b.id_titulo))
                    .map((practicario, index) => {
                      // Extraer grado de la URL (e.g., "grado1/" -> "Grado 1")
                      const gradoMatch = practicario.url?.match(/grado(\d+)\//i);
                      const grado = gradoMatch ? `${gradoMatch[1]}` : '—';
                      
                      return (
                        <tr
                          key={index}
                          className="hover:bg-gray-100 cursor-pointer"
                          onClick={() => {
                            selectTitle(practicario.id_titulo, practicario.id_titulo + " - " + practicario.nombre + (practicario.tema ? " - " + practicario.tema : ""), practicario.url);
                            toggleInfoModal();
                          }}
                        >
                          <td className="border border-gray-300 px-4 py-2">{practicario.id_titulo}</td>
                          <td className="border border-gray-300 px-4 py-2">{practicario.nombre}</td>
                          <td className="border border-gray-300 px-4 py-2">{practicario.tema || '—'}</td>
                          <td className="border border-gray-300 px-4 py-2">{grado}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default ConstructorPracticarios;
